import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff9ecc4e")

_pushScopeId("data-v-ff9ecc4e")
const _hoisted_1 = { class: "transition_container" }
const _hoisted_2 = { class: "transition_anim" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "transition_dyk" }, [
  /*#__PURE__*/_createVNode("div", { class: "transition_container_title" }, "DID YOU KNOW?"),
  /*#__PURE__*/_createVNode("div", { class: "transition_container_subtitle" }, [
    /*#__PURE__*/_createTextVNode(" Our brains process images"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("strong", null, "60,000"),
    /*#__PURE__*/_createTextVNode(" times more than text. ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lottie = _resolveComponent("lottie")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_lottie, { options: _ctx.defaultOptions }, null, 8, ["options"])
    ]),
    _hoisted_3
  ]))
})